import axios from "../../lib/axios"
import { GetProviderService } from "../main/types"

// User Facility
const getUserFacility = () => {
  return axios.get("/api/v1/facility/getAllfacilityRequest")
}

const getProvidersList: GetProviderService = ({ params }) => {
  return axios.get("/api/v1/provider/getAllProvierFacilityBasedOnAmount", { params })
}

const selectProvider = id => {
  return axios.post("/api/v1/facility/facilityRequest", { id: id })
}

const authentication = date => {
  return axios.put("/api/v1/facility/getUserInfoInquiry", { birthDate: date })
}

const checkCardNumber = cardNumber => {
  return axios.put("/api/v1/facility/getBankInquiry", { cardNumber: `610433${cardNumber}` })
}

const handleRules = () => {
  return axios.put("/api/v1/facility/approveRule")
}

const handlePayment = () => {
  return axios.put("/api/v1/facility/payInquiryFee")
}

const handleFacilityInquiry = () => {
  return axios.put("/api/v1/facility/getFacilityInquiry")
}

const handleValidationRequest = (facilityId: number) => {
  return axios.put(`/api/v1/facility/getCreditratingOtp?facilityRequestId=${facilityId}`)
}

const handleValidationReport = (code, facilityId) => {
  return axios.put("/api/v1/facility/getCreditratingReport", { otp: code, facilityRequestId: facilityId })
}

const updateFacilityAmount = (facilityId, facilityRequestId) => {
  return axios.put("/api/v1/facility/updateFacilityAmount", { providerFacilityId: facilityId, facilityRequestId })
}

const handlePostalCodeInquiry = code => {
  return axios.put("/api/v1/facility/getPostalCodeInquiry", { PostalCode: code })
}
const handleUpdatePostalCodeInfo = description => {
  return axios.put("/api/v1/facility/updatePostalCodeInfo", { Description: description })
}

const uploadDocument = (file, info) => {
  return axios.post("/api/v1/facility/uploadChequeImage", { file, ...info })
}

const handleWagePayment = () => {
  return axios.put("/api/v1/facility/payWageAmount")
}

const signContract = (facilityId: number) => {
  return axios.put(`/api/v1/facility/signContract?facilityRequestId=${facilityId}`)
}

const isfacilityRequestAvailable = () => {
  return axios.get("/api/v1/facility/isfacilityRequestAvailable")
}

const getKycStatus = () => {
  return axios.get("/api/v1/kyc/isVerifyEkyc")
}

const handleKycRequest = data => {
  return axios.get("/api/v1/kyc/kycRequest", {
    params: {
      CardSerialNumber: data?.cardSerial,
      EnFirstName: data?.firstName,
      EnLastName: data?.lastName
    }
  })
}

const sendKycRequest = data => {
  return axios.get("/api/v1/kyc/ekycRequest", {
    params: {
      CardSerialNumber: data?.cardSerial,
      EnFirstName: data?.firstName,
      EnLastName: data?.lastName
    }
  })
}
function saveSignature(ekycRequestId, fileData) {
  return axios.post("/api/v1/kyc/saveSignature", {
    ekycRequestId,
    fileData
  })
}
function loadKycData(ekycRequestId) {
  return axios.get("/api/v1/kyc/getEkycData", {
    params: { ekycRequestId }
  })
}
function saveSelfie(ekycRequestId, fileData) {
  return axios.post("/api/v1/kyc/saveSelfieImage", {
    ekycRequestId,
    fileData
  })
}
function saveSelfieVideo(ekycRequestId, fileData) {
  return axios.post("/api/v1/kyc/saveSelfieVideo", {
    ekycRequestId,
    fileData
  })
}
function getRandomText(ekycRequestId) {
  return axios.get("/api/v1/kyc/getRandomText", {
    params: { EkycRequestId: ekycRequestId }
  })
}

const chequeRequest = () => {
  return axios.get("/api/v1/promissoryNote/request")
}

const getSignedPromissoryNote = () => {
  return axios.get("/api/v1/promissoryNote/getSignedPromissoryNote")
}

const inquiryPromissoryNoteAmount = () => {
  return axios.get("/api/v1/promissoryNote/inquiryPromissoryNoteAmount")
}

const getContractPreview = (facilityId: number) => {
  return axios.get("/api/v1/facility/getContractPreview", { params: { facilityRequestId: facilityId } })
}

const handleAssignCredit = () => {
  return axios.put("/api/v1/facility/assignCredit")
}

const deleteRequest = (facilityRequestId: number) => {
  return axios.delete(`/api/v1/facility/deleteFacilityInquiry?FacilityRequestId=${facilityRequestId}`)
}

const checkCreditTransferAvalibility = () => {
  return axios.get("/api/v1/payment/checkCreditTransferAvalibility")
}

const transferCredit = data => {
  return axios.post("/api/v1/payment/transferCredit", data)
}

const getTransferCreditAmounts = params => {
  return axios.get("/api/v1/payment/getTransferCreditAmounts", { params })
}

const getUserFacilityHistory = () => {
  return axios.get("/api/v1/facility/getClosedFacilityRequestHistory")
}

const getFacilityRequestFlow = params => {
  return axios.get("/api/v1/facility/getFacilityRequestFlow", { params })
}
const getDocumentTypeBasedOnCareer = data => {
  return axios.post("/api/v1/facility/getDocumentTypeBasedOnCareer", data)
}
const setEducationAndCareerInformation = data => {
  return axios.post("/api/v1/facility/setEducationAndCareerInformation", data)
}
const getProfile = () => {
  return axios.get("/api/v1/account/getProfile")
}
const getJetClubPlanList = () => {
  return axios.get("/api/v1/facility/getJetClubPlanList")
}

const requests = {
  getUserFacility,
  getProvidersList,
  selectProvider,
  checkCardNumber,
  authentication,
  handleRules,
  handlePayment,
  handleFacilityInquiry,
  handleValidationRequest,
  handleValidationReport,
  handlePostalCodeInquiry,
  handleUpdatePostalCodeInfo,
  updateFacilityAmount,
  uploadDocument,
  handleWagePayment,
  signContract,
  getKycStatus,
  handleKycRequest,
  sendKycRequest,
  saveSignature,
  saveSelfie,
  saveSelfieVideo,
  getContractPreview,
  deleteRequest,
  handleAssignCredit,
  chequeRequest,
  getSignedPromissoryNote,
  inquiryPromissoryNoteAmount,
  checkCreditTransferAvalibility,
  transferCredit,
  getRandomText,
  loadKycData,
  isfacilityRequestAvailable,
  getTransferCreditAmounts,
  getUserFacilityHistory,
  getFacilityRequestFlow,
  getDocumentTypeBasedOnCareer,
  setEducationAndCareerInformation,
  getProfile,
  getJetClubPlanList
}

export default requests
